module.exports = __webpack_public_path__ + "img/qd-marca_preta.c8615440.png";